const PERFIL_CLIENTE = "CLI";
const PERFIL_ADMININSTRADOR = "ADM";
const PERFIL_AUDITOR = "AUD";
const PERFIL_FORNECEDOR = "FOR";
const PERFIL_GESTOR_API= "API";
const PERFIL_MANTENEDOR= "MAN";

export {PERFIL_CLIENTE, PERFIL_ADMININSTRADOR, PERFIL_AUDITOR, PERFIL_FORNECEDOR, PERFIL_GESTOR_API, PERFIL_MANTENEDOR}